import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { loadAppConfig, resolveApiBaseUrl } from "./utils/config";

const initI18n = async () => {
  try {
    let supportedLanguages: string[] = ['he', 'en-US'];

    const config = await loadAppConfig();
    const apiBaseUrl = resolveApiBaseUrl(config);

    try {
      const resLang = await fetch(`${apiBaseUrl}languages`);
      const data = await resLang.json();
      if (Array.isArray(data)) {
        supportedLanguages = data
          .filter(lang => lang.statusId && typeof lang.code === 'string')
          .map(lang => lang.code.trim());
      }
    } catch (error) {
      console.error('שגיאה בשליפת שפות מהשרת, משתמשים בברירת מחדל:', error);
    }

    await i18n
      .use(HttpApi)
      .use(LanguageDetector)
      .init({
        supportedLngs: supportedLanguages,
        fallbackLng: 'he',
        detection: {
          order: ['localStorage'],
          caches: ['localStorage']
        },
        backend: {
          loadPath: `${apiBaseUrl}Languages/GetCurrentLocales/therapist/{{lng}}`,
          // loadPath: '/locales/locale-{{lng}}.json'        
        }
      }
      );

  } catch (error) {
    console.error('שגיאה באתחול i18n:', error);
  }
};

export { initI18n };
export default i18n;